import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import SourceFlowForm from '@sourceflow-uk/sourceflowform';
import {
    Container,
    Col,
    Row,
    CardImg,
    Card,
} from 'reactstrap';
import styles from './styles.module.scss';
import Link from "next/link"

export default function SimpleContent({
    global,
    pathPrefix,
    customClass = "",
    content,
    editableText = true,
    buttonTitle1 = "",
    buttonTitleLink1 = ""
}) {

    return (
        <>
            {
                content ?
                    <section className={`${styles.root} ${customClass}`}>
                        <Container>
                            {content ?
                                editableText ?
                                    <div className="mainContent">
                                        <SourceFlowText global={global} path={`${pathPrefix}.content`} type="html">
                                            {content}
                                        </SourceFlowText>
                                    </div> : <div className="mainContent">{content}</div> : ""}
                            {buttonTitleLink1 ?
                                <div>
                                    <Link href={`${buttonTitleLink1}`}>
                                        <a className="primaryBtn no-arrow">
                                            <SourceFlowText global={global} path={`${pathPrefix}.buttonTitle1`} >
                                                {buttonTitle1}
                                            </SourceFlowText>
                                        </a>
                                    </Link>
                                </div> : null}
                        </Container>
                    </section > : ""}
        </>

    )
}